// extracted by mini-css-extract-plugin
export default {"bankCarsWrapper":"PageApplications_bankCarsWrapper__jLqm3","applicationCard":"PageApplications_applicationCard__1JhAp","redBackground":"PageApplications_redBackground__wg6ul"};